import { createActionType } from "Common/namespaceUtils/namespaceRedux";
import { FULL_NAMESPACE } from "../constants";
export default {
    SET_ONTOLOGICAL_MODEL: createActionType(FULL_NAMESPACE, "SET_ONTOLOGICAL_MODEL"),
    SET_OUTDATED: createActionType(FULL_NAMESPACE, "SET_OUTDATED"),
    SET_USED_BY_UI: createActionType(FULL_NAMESPACE, "SET_USED_BY_UI"),
    SET_DETAILED_PANEL_OPEN: createActionType(FULL_NAMESPACE, "SET_DETAILED_PANEL_OPEN"),
    DOWNLOAD_ONTOLOGICAL_MODEL: createActionType(FULL_NAMESPACE, "DOWNLOAD_ONTOLOGICAL_MODEL"),
    UPLOAD_ONTOLOGICAL_MODEL: createActionType(FULL_NAMESPACE, "UPLOAD_ONTOLOGICAL_MODEL"),
    GET_ONTOLOGICAL_MODEL: createActionType(FULL_NAMESPACE, "GET_ONTOLOGICAL_MODEL"),
    GET_ONTOLOGICAL_MODEL_COMPLETED: createActionType(FULL_NAMESPACE, "GET_ONTOLOGICAL_MODEL_COMPLETED"),
    SAVE_ONTOLOGICAL_MODEL: createActionType(FULL_NAMESPACE, "SAVE_ONTOLOGICAL_MODEL"),
    SAVE_ONTOLOGICAL_MODEL_COMPLETED: createActionType(FULL_NAMESPACE, "SAVE_ONTOLOGICAL_MODEL_COMPLETED"),
    SAVE_ONTOLOGICAL_MODEL_REJECTED: createActionType(FULL_NAMESPACE, "SAVE_ONTOLOGICAL_MODEL_REJECTED"),
    RELOAD_ONTOLOGY: createActionType(FULL_NAMESPACE, "RELOAD_ONTOLOGY"),
    EXPORT_ONTOLOGY: createActionType(FULL_NAMESPACE, "EXPORT_ONTOLOGY"),
    SET_HAS_CHANGES: createActionType(FULL_NAMESPACE, "SET_HAS_CHANGES"),
    SET_LAYOUT_ALGORITHM: createActionType(FULL_NAMESPACE, "SET_LAYOUT_ALGORITHM"),
    SET_SHOW_NAMES: createActionType(FULL_NAMESPACE, "SET_SHOW_NAMES"),
    SET_FILTER_TEXT: createActionType(FULL_NAMESPACE, "SET_FILTER_TEXT"),
    SET_PANEL_WIDTH: createActionType(FULL_NAMESPACE, "SET_PANEL_WIDTH")
};
